export const OnboardCancel = () => {
    return (
        <>Aqui vai a tela de cancelamento</>
    )
}